import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HashRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'

import emailjs from '@emailjs/browser'
import { EMAILJS_CONFIG } from './config/emailjs.js'
emailjs.init({
  publicKey: EMAILJS_CONFIG.publicKey,
  blockHeadless: true,
})

import App from './App.jsx'
import './styles/globals.css'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <HelmetProvider>
      <HashRouter>
        <App />
      </HashRouter>
    </HelmetProvider>
  </StrictMode>,
)
